type RoleChipProps = {
  text: string;
  color: string;
};

export const RoleChip: React.FC<RoleChipProps> = ({ text, color }) => {
  return (
    <div
      className={`px-3 py-1 body-2-medium rounded-lg chip-${color}-bg chip-${color}-fg`}
    >
      {text}
    </div>
  );
};
